import { Lock, LockOpen } from '@mui/icons-material'
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { HeightIcon } from '@tom-ui/ui'
import { ConfigAreaType } from '@yard/app/api'

interface YardBlockSlotsContextMenuProps {
  open: boolean
  anchorPosition: { top: number; left: number } | undefined
  onClose: () => void
  onBlockConfigArea?: () => void
  onDeleteConfigArea?: (type: ConfigAreaType) => void
  onAdjustMaxTier: () => void
}

export const YardBlockSlotsContextMenu = (props: YardBlockSlotsContextMenuProps) => {
  const { t } = useTranslate()
  const { open, anchorPosition, onClose, onBlockConfigArea, onDeleteConfigArea, onAdjustMaxTier } =
    props

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference='anchorPosition'
      anchorPosition={anchorPosition}
    >
      <MenuItem
        onClick={() => {
          onAdjustMaxTier()
          onClose()
        }}
        className='nodrag'
      >
        <ListItemIcon>
          <HeightIcon fontSize='small' />
        </ListItemIcon>
        <ListItemText>{t('adjustMaxTier', 'Adjust max tier')}</ListItemText>
      </MenuItem>

      {onBlockConfigArea && (
        <MenuItem
          onClick={() => {
            onBlockConfigArea()
            onClose()
          }}
          className='nodrag'
        >
          <ListItemIcon>
            <Lock fontSize='small' />
          </ListItemIcon>
          <ListItemText>{t('restrictBayAcess', 'Restrict bay access')}</ListItemText>
        </MenuItem>
      )}

      {onDeleteConfigArea && (
        <MenuItem
          onClick={() => {
            onDeleteConfigArea(ConfigAreaType.IsBlocked)
            onClose()
          }}
          className='nodrag'
        >
          <ListItemIcon>
            <LockOpen fontSize='small' />
          </ListItemIcon>
          <ListItemText>{t('unrestrictBayAcess', 'Unrestrict bay access')}</ListItemText>
        </MenuItem>
      )}
    </Menu>
  )
}
